export const transformGuestDataToPayload = (guests) => {
  const sharedWaiverArray = []

  guests?.forEach((guest) => {
    if (guest.sendMethod === "text") {
      guest.phones?.forEach((phone) => {
        if (phone?.fullNumber?.trim()) {
          sharedWaiverArray.push({
            share_by: "text",
            phone_number: phone.fullNumber
          })
        }
      })
    } else if (guest.sendMethod === "email") {
      guest.emails?.forEach((email) => {
        if (email?.trim()) {
          sharedWaiverArray.push({
            share_by: "email",
            email: email
          })
        }
      })
    }
  })

  return sharedWaiverArray
}

export const createGuestField = (id) => ({
  id,
  sendMethod: "text",
  phoneFields: [{ name: 0, key: Date.now(), isListField: true }],
  emailFields: [{ name: 0, key: Date.now() + 1, isListField: true }]
})

export const getInitialGuestState = () => [createGuestField(0)]

export const getFormInitialValues = () => ({
  guests: [
    {
      sendMethod: "text",
      phones: [{ countryCode: "US", fullNumber: "" }],
      emails: [""]
    }
  ]
})
